import { FC, Fragment } from 'react';
import { MatchResult } from './types';
type TeamMatchTrackerProps = {
  result: MatchResult[];
};
export const TeamMatchTracker: FC<TeamMatchTrackerProps> = ({
  result
}) => {
  if (result.length < 2) {
    return <></>;
  }
  const [teamA, teamB] = result;
  const totalPoints = teamA.score + teamB.score;
  const generateRows = () => {
    let divs: React.JSX.Element[] = [];
    for (let index = 0; index < totalPoints; index++) {
      const teamARemainder = teamA.score - index;
      const teamBRemainder = index + 1 - (totalPoints - teamB.score);
      const amberClasses = 'h-full';
      const amberStyle = {
        backgroundColor: teamA.color
      };
      const tealClasses = 'h-full';
      const tealStyle = {
        backgroundColor: teamB.color
      };
      if (teamARemainder >= 1) {
        divs.push(<div key={index} className={`w-full ${amberClasses}`} style={amberStyle}></div>);
      } else if (teamARemainder === 0.5) {
        if (teamBRemainder === 0.5) {
          divs.push(<Fragment key={index}>
              <div className={`w-1/2 ${amberClasses}`} style={amberStyle}></div>
              <div className={`w-1/2 ${tealClasses}`} style={tealStyle}></div>
            </Fragment>);
        } else {
          divs.push(<Fragment key={index}>
              <div className={`w-1/2 ${tealClasses}`} style={tealStyle}></div>
              <div className="w-1/2 h-full bg-gray-400"></div>
            </Fragment>);
        }
      } else if (teamBRemainder === 0.5) {
        divs.push(<Fragment key={index}>
            <div className="w-1/2 h-full bg-gray-400"></div>

            <div className={`w-1/2 ${amberClasses}`} style={amberStyle}></div>
          </Fragment>);
      } else if (teamBRemainder >= 1) {
        divs.push(<div key={index} className={`w-full ${tealClasses}`} style={tealStyle}></div>);
      } else {
        divs.push(<div key={index} className="w-full h-full bg-gray-400"></div>);
      }
    }
    return divs;
  };
  return <div className="border border-gray-200 p-0.5 w-full rounded-full" data-sentry-component="TeamMatchTracker" data-sentry-source-file="team-match-tracker.tsx">
      <div className="flex space-x-px h-2 lg:h-[10px] w-full rounded-full overflow-clip bg-gray-100 divide-x-2 divide-white">
        {generateRows()}
      </div>
    </div>;
};